import { StyleSheet, ScrollView, View, Dimensions, Pressable, Linking, Image } from "react-native";
import { FindifyTopBarOverlay } from "../genericPages/components/FindifyTopBarOverlay";
import Icon from "react-native-vector-icons/Ionicons";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { BasePage } from "../genericPages/helpers/BasePage";
import { FindifyHTMLRender } from "../genericPages/helpers/FindifyHTMLRender";
import { FindifySimpleHeader } from "../genericPages/components/FindifySimpleHeader";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import { BottomNavigationPadding } from "../genericPages/components/FindifyNavigation";
import { useTranslation } from "react-i18next";
import { openSocial } from "../genericPages/PlaceInfo";
import { getApiFromModule } from "../genericPages/helpers/GetContentsByModule";
import { getFeaturedImageUrl } from "../genericPages/helpers/DetailsHelpers";

const makePlaceActionIcon = (action: Function, logo: string, findifyDataContext: any) => {
    return <Pressable onPress={() => action()}>
        <Icon style={{ color: PlaceColors(findifyDataContext).text.get() }} name={logo} size={30} />
    </Pressable>
}


export const PlaceInfoTab = ({ navigation }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const contentsApi = getApiFromModule('contents', findifyDataContext)
    const [infoContent, setInfoContent] = useState<any>({});
    const [renderImageSize, setRenderImageSize] = useState<any>({});
    const { t } = useTranslation();
    useEffect(() => {
        contentsApi.get(findifyDataContext?.workspace?.app_settings?.place_info, null, null).then((res) => {
            setInfoContent(res);
            Image.getSize(getFeaturedImageUrl(res), (width, height) => {
                const imgSizeObj = { width, height };
                setRenderImageSize({
                    width: (Dimensions.get('window').width - 20),
                    height: ((Dimensions.get('window').width - 20) / imgSizeObj.width) * imgSizeObj.height,
                })
            });

        })
    }, [])

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <ScrollView
            bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={[styles.container, { backgroundColor: PlaceColors(findifyDataContext).background.get(), paddingBottom: BottomNavigationPadding }]}>
            <FindifySimpleHeader navigation={navigation}
                title={getTranslatedString(infoContent?.name, findifyDataContext)}
            />
            <View style={{ padding: 10 }}>
                <FindifyHTMLRender
                    baseStyles={{
                        color: PlaceColors(findifyDataContext).text.get(),
                    }}
                    htmlCode={getTranslatedString(infoContent?.description, findifyDataContext)} />
            </View>


            <Image
                style={{
                    ...renderImageSize,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: 10,
                    marginBottom: 10,
                }}
                resizeMode="contain"
                source={{ uri: getFeaturedImageUrl(infoContent) }} />
            {(findifyDataContext.workspace?.app_settings?.socials_lines?.length ?? 0) > 0 &&
                <View style={{
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    gap: 10,
                    // justifyContent: 'space-around',
                    // backgroundColor: PlaceColors(findifyDataContext).text.withAlpha(80),
                }}>
                    {findifyDataContext.workspace?.app_settings?.socials_lines.map((line: any, index: number) => {
                        return makePlaceActionIcon(() => openSocial(navigation, line, t), line?.icon, findifyDataContext);
                    })}
                </View>
            }
        </ScrollView>
    </BasePage>;
};


const styles = StyleSheet.create({

    container: {
        height: '100%',
        width: '100%',
    },
    map: {
        flex: 1
    }

})